export default {
  routes: {
    path: '/rotas',
    name: 'Todas as rotas'
  },
  root: {
    path: '/',
    name: 'Landing'
  },
  login: {
    path: '/login',
    name: 'Login'
  },
  loginAuth: {
    path: '/login/autenticacao',
    name: 'Login autenticação'
  },
  registerCNPJ: {
    path: '/cadastro/cnpj',
    name: 'Cadastro cnpj'
  },
  registerEmail: {
    path: '/cadastro/email',
    name: 'Cadastro email'
  },
  registerPhone: {
    path: '/cadastro/telefone',
    name: 'Cadastro telefone'
  },
  registerPassword: {
    path: '/cadastro/senha',
    name: 'Cadastro senha'
  },
  registerPhoneConfirm: {
    path: '/cadastro/telefone/confirmacao'
  },
  registerEmailConfirm: {
    path: '/cadastro/email/confirmacao'
  },
  registerEmailConfirmReceive: {
    path: '/cadastro/email/confirmacao/processando'
  },
  registerEmailConfirmSuccess: {
    path: '/cadastro/email/confirmacao/sucesso'
  },
  registerEmailConfirmFail: {
    path: '/cadastro/email/confirmacao/falha'
  },
  registerFeedbackValidate: {
    path: '/cadastro/validacao',
    name: 'Cadastro validação'
  },
  registerEmailConfirmed: {
    path: '/cadastro/email-confirmado',
    name: 'Cadastro email confirmado'
  },
  registerAlterEmail: {
    path: '/cadastro/alterar/email',
    name: 'Cadastro alterar email'
  },
  registerSuccessFeedback: {
    path: '/cadastro/sucesso',
    name: 'Cadastro feito com sucesso'
  },
  resetPasswordSentEmail: {
    path: '/redefinir-senha/email',
    name: 'Redefinir senha email'
  },
  resetPasswordSentEmailFeedback: {
    path: '/redefinir-senha/email/feedback',
    name: 'Redefinir senha email feedback 1'
  },
  resetPasswordResentEmailFeedback: {
    path: '/redefinir-senha/email/feedback/reenviado',
    name: 'Redefinir senha email feedback enviado'
  },
  firstAccess: {
    path: '/primeiro-acesso',
    name: 'Redefinir senha'
  },
  resetPasswordSentPassword: {
    path: '/redefinir-senha/senha',
    name: 'Redefinir senha'
  },
  resetPasswordAuth: {
    path: '/redefinir-senha/senha/autenticacao',
    name: 'Refefinir senha autenticação'
  },
  resetPasswordSentPasswordFeedback: {
    path: '/redefinir-senha/senha/feedback',
    name: 'Redefinir senha feedback'
  },
  resetPasswordSuccessfully: {
    path: '/redefinir-senha/email/sucesso',
    name: 'Redefinir senha email sucesso'
  },
  terms: {
    path: '/termos-e-confidencialidade',
    name: 'Termos'
  },
  termsInternal: {
    path: '/termos-e-confidencialidade-aceito',
    name: 'Termos'
  },
  termsRefuse: {
    path: '/termos-e-confidencialidade/recusado',
    name: 'Termos Recusado'
  },
  loginBlocked: {
    path: '/login/bloqueado',
    name: 'Login Bloqueado'
  },
  dashboard: {
    path: '/dashboard/:roleId',
    name: 'Dashboard'
  },
  profile: {
    path: '/perfil',
    name: 'Perfil parceiro'
  },
  profileDetail: {
    path: '/perfil/detalhe',
    name: 'Perfil Detalhe'
  },
  profileStoreDetail: {
    path: '/perfil/detalhe/loja',
    name: 'Perfil Dados da Empresa'
  },
  wallet: {
    path: '/carteira',
    name: 'Carteira'
  },
  walletSearch: {
    path: '/carteira/busca/:search',
    name: 'Busca na Carteira',
    generate: (search) => `/carteira/busca/${search}`
  },
  extract: {
    path: '/extrato/:id',
    name: 'Extrato',
    generate: (id) => `/extrato/${id}`
  },
  extractIndicatorsManagerial: {
    path: '/extrato/detalhe/gerencial',
    name: 'Extrato nível 1'
  },
  extractDetailTwo: {
    path: '/extrato/:storeTabNumber/detalhe/gerencial/:id',
    name: 'Extrato nível 2',
    generate: (storeTabNumber, id) =>
      `/extrato/${storeTabNumber}/detalhe/gerencial/${id}`
  },
  detailStore: {
    path: '/extrato/loja/detalhe/:id',
    name: 'Dados da loja',
    generate: (storeTabNumber, id) => `/extrato/loja/detalhe/${id}`
  },
  detailProduct: {
    path: '/extrato/:id/produto/:idProduct',
    name: 'Extrato Produto',
    generate: (id, idProduct) => `/extrato/${id}/produto/${idProduct}`
  },
  content: {
    path: '/conteudo',
    name: 'Base de conhecimento'
  },
  contentSearch: {
    path: '/conteudo/busca/:search',
    name: 'Busca na Base de conhecimento',
    generate: (search) => `/conteudo/busca/${search}`
  },
  contentDetail: {
    path: '/conteudo/:contentId/detalhe',
    name: 'Detalhes do Conteudo (Base de conhecimento)',
    generate: (contentId) => `/conteudo/${contentId}/detalhe`
  },
  timeline: {
    path: '/historico',
    name: 'Histórico (Timeline)'
  },
  timelineForm: {
    path: '/historico/novo',
    name: 'Histórico Adicionar'
  },
  awaitingApproval: {
    path: '/cadastro/aguardando-aprovacao',
    name: 'Aguardando Aprovação'
  },
  people: {
    list: {
      path: '/pessoas',
      name: 'Pessoas'
    },
    detail: {
      path: '/pessoas/:id',
      name: 'Detalhes',
      generate: (personId) => `/pessoas/${personId}`
    },
    personalData: {
      path: '/pessoas/:id/informacoes',
      name: 'Pessoais',
      generate: (personId) => `/pessoas/${personId}/informacoes`
    },
    company: {
      path: '/pessoas/:id/empresa',
      name: 'Empresa',
      generate: (personId) => `/pessoas/${personId}/empresa`
    }
  }
}
